import jim from "./speaker_headshots/jim_walseth.jpeg"
import kamila from "./speaker_headshots/KamilaStepniowska2020.jpg"
import paul from "./speaker_headshots/paulDooley.jpeg"
import  githubio from './project_images/ws7Q0-removebg-preview.png'

const images = {
    'jim': jim,
    "kamila": kamila,
    "paul": paul
}

export default images;
